"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeroToJSON = exports.HeroFromJSONTyped = exports.HeroFromJSON = exports.instanceOfHero = void 0;
var runtime_1 = require("../runtime");
var ShopHeroLink_1 = require("./ShopHeroLink");
/**
 * Check if a given object implements the Hero interface.
 */
function instanceOfHero(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfHero = instanceOfHero;
function HeroFromJSON(json) {
    return HeroFromJSONTyped(json, false);
}
exports.HeroFromJSON = HeroFromJSON;
function HeroFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'heroImageUrl': !(0, runtime_1.exists)(json, 'heroImageUrl') ? undefined : json['heroImageUrl'],
        'heroHeading': !(0, runtime_1.exists)(json, 'heroHeading') ? undefined : json['heroHeading'],
        'heroText': !(0, runtime_1.exists)(json, 'heroText') ? undefined : json['heroText'],
        'heroTextColor': !(0, runtime_1.exists)(json, 'heroTextColor') ? undefined : json['heroTextColor'],
        'heroLinks': !(0, runtime_1.exists)(json, 'heroLinks') ? undefined : (json['heroLinks'] === null ? null : json['heroLinks'].map(ShopHeroLink_1.ShopHeroLinkFromJSON)),
    };
}
exports.HeroFromJSONTyped = HeroFromJSONTyped;
function HeroToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'heroImageUrl': value.heroImageUrl,
        'heroHeading': value.heroHeading,
        'heroText': value.heroText,
        'heroTextColor': value.heroTextColor,
        'heroLinks': value.heroLinks === undefined ? undefined : (value.heroLinks === null ? null : value.heroLinks.map(ShopHeroLink_1.ShopHeroLinkToJSON)),
    };
}
exports.HeroToJSON = HeroToJSON;
